import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Autoplay, FreeMode } from "swiper/modules";
import MuxPlayer from "@mux/mux-player-react";

import "swiper/css";
import "./HomeSlider.css";

const HomeSlider = ({ videos = [] }) => {
  /* keep refs for every Mux player in rendering order */
  const playerRefs = useRef([]);

  /* helper to pause all except the index that started playing */
  const handlePlay = (idx) => () => {
    playerRefs.current.forEach((player, i) => {
      if (i !== idx && player && !player.paused) {
        player.pause();
      }
    });
  };

  /* make sure refs array length matches videos length */
  useEffect(() => {
    playerRefs.current.length = videos.length;
  }, [videos.length]);

  useEffect(() => {
    const loader = document.getElementById("home-slider-loader");
    if (loader) loader.style.display = "none";
  }, []);

  if (!videos.length) return null;

  return (
    <div className="home-slider-container">
      <Swiper
        modules={[Mousewheel, Autoplay, FreeMode]}
        mousewheel={true}
        freeMode={true}
        slideToClickedSlide={true}
        initialSlide={0}
        grabCursor
        loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        spaceBetween={16}
        breakpoints={{
          0: { slidesPerView: 1.5 },
          576: { slidesPerView: 2.5 },
          768: { slidesPerView: 3.5 },
        }}
        className="home-swiper"
      >
        {videos.map((v, idx) => (
          <SwiperSlide key={v.id} className="home-slide">
            <div className="video-frame">
              <MuxPlayer
                className="mux-player"
                playbackId={v.mux_playback_id}
                streamType="on-demand"
                controls
                loop
                playsInline
                preload="metadata"
                thumbnailTime={0}
                poster={`https://mux.jobpeeks.com/${v.mux_playback_id}/thumbnail.jpg?time=0&width=360&height=640&fit_mode=pad`}
                /* store element ref & attach play handler */
                ref={(el) => (playerRefs.current[idx] = el)}
                onPlay={handlePlay(idx)}
              />
            </div>
            <div className="slide-caption">{v.title}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeSlider;
